import { useCardSectionRegistry } from '../../hooks/useCardSectionRegistry';
import { useMemo } from 'react';
export const useCardActionPreviewSections = settings => {
  const {
    data: registry
  } = useCardSectionRegistry();
  return useMemo(() => {
    return settings.quickActions.map(action => {
      return {
        sectionKey: action.type,
        PreviewComponent: registry.getSectionPreviewComponent(action.type)
      };
    });
  }, [settings, registry]);
};